import { defineMessages } from 'react-intl-next';
export const messages = defineMessages({
  atlassianIntelligenceLabel: {
    id: 'proforma-project-forms.create-form-button.atlassian-intelligence-label',
    defaultMessage: 'Atlassian Intelligence',
    description: 'Label for Atlassian Intelligence icon'
  },
  createFromImport: {
    id: 'proforma-project-forms.create-form-button.convert-form',
    defaultMessage: 'Create from import',
    description: 'Option to create a form from import'
  },
  createFormTrigger: {
    id: 'proforma-project-forms.create-form-button.trigger',
    defaultMessage: 'Create form',
    description: 'Trigger for dropdown to create a new form'
  },
  createFormTemplate: {
    id: 'proforma-project-forms.create-form-button.create-with-template',
    defaultMessage: 'Create from template',
    description: 'Option to create a new form from a template'
  },
  createFormBlank: {
    id: 'proforma-project-forms.create-form-button.create-blank',
    defaultMessage: 'Create blank',
    description: 'Option to create a new blank form'
  },
  createFormFromBlank: {
    id: 'proforma-project-forms.create-form-button.create-from-blank',
    defaultMessage: 'Create from blank',
    description: 'Option to create a new blank form'
  }
});